import { useEffect, useCallback, useRef } from 'react';
import { focusFirstField } from './focus-first-field';
export const useScrollToTopOfForm = (formId, stepId) => {
    const shouldScrollOnStepChange = useRef(false);
    const scrollToTopOfForm = useCallback(() => {
        const formElement = document
            .getElementById(`form-${formId}`)
            ?.closest('[data-hook="Form-wrapper"]');
        if (formElement) {
            const { top } = formElement.getBoundingClientRect();
            if (top < 0 || top > window.innerHeight) {
                const newTop = top + window.scrollY - 20;
                window.scrollTo({ top: newTop, behavior: 'smooth' });
            }
            focusFirstField(formId);
        }
    }, [formId]);
    useEffect(() => {
        if (shouldScrollOnStepChange.current) {
            scrollToTopOfForm();
            shouldScrollOnStepChange.current = false;
        }
        // We want to rely on stepId only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [stepId]);
    return useCallback(() => {
        shouldScrollOnStepChange.current = true;
    }, []);
};
//# sourceMappingURL=use-scroll-to-top-of-form.js.map